const STORAGE_KEY = "puppy-academy-attribution";

const PARAMETER_MAP = {
  gclid: "gclid",
  gbraid: "gbraid",
  wbraid: "wbraid",
  utm_source: "utmSource",
  utm_medium: "utmMedium",
  utm_campaign: "utmCampaign",
  utm_term: "utmTerm",
  utm_content: "utmContent",
};

const EMPTY_ATTRIBUTION = {
  gclid: null,
  gbraid: null,
  wbraid: null,
  utmSource: null,
  utmMedium: null,
  utmCampaign: null,
  utmTerm: null,
  utmContent: null,
  landingPageUrl: null,
};

function readStoredAttribution() {
  try {
    const stored = window.sessionStorage.getItem(STORAGE_KEY);
    return stored ? { ...EMPTY_ATTRIBUTION, ...JSON.parse(stored) } : { ...EMPTY_ATTRIBUTION };
  } catch {
    return { ...EMPTY_ATTRIBUTION };
  }
}

export function captureAttribution() {
  const attribution = readStoredAttribution();
  const params = new URLSearchParams(window.location.search);

  if (!attribution.landingPageUrl) attribution.landingPageUrl = window.location.href;

  Object.entries(PARAMETER_MAP).forEach(([parameter, field]) => {
    const value = params.get(parameter);
    if (value) attribution[field] = value;
  });

  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(attribution));
  } catch (error) {
    console.warn("Unable to save consultation attribution.", error);
  }

  return attribution;
}

export function getAttribution() {
  return readStoredAttribution();
}